import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

interface SensitiveFieldProps {
  value: any;
  renderValue: (value: any) => React.ReactNode;
  hiddenPlaceholder?: string;
  className?: string;
  minWidth?: string; // optional custom min width
}

const SensitiveField: React.FC<SensitiveFieldProps> = ({
  value,
  renderValue,
  hiddenPlaceholder = "••••••",
  className = "",
  minWidth = "120px", // default min width
}) => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsVisible(!isVisible);
  };

  return (
    <div className={`relative flex items-center gap-2 ${className}`} style={{ minWidth }}>
      <div className="flex-1 min-w-0 overflow-hidden">
        {isVisible ? renderValue(value) : <span className="text-gray-500">{hiddenPlaceholder}</span>}
      </div>
      <button
        onClick={toggleVisibility}
        className="flex-shrink-0 p-1 hover:bg-gray-100 rounded-full transition-colors"
        type="button"
        aria-label={isVisible ? "Hide value" : "Show value"}
      >
        {isVisible ? (
          <Eye className="w-4 h-4 text-gray-600" />
        ) : (
          <EyeOff className="w-4 h-4 text-gray-600" />
        )}
      </button>
    </div>
  );
};

export default SensitiveField;
